import React from 'react';
import type { ReviewKind } from './types';
import { KIND_META } from './constants';
import { approveAllEventName, dismissAllEventName } from './archive/constants';

interface Props {
  kind: ReviewKind;
}

export default function HeaderActions({ kind }: Props): React.ReactElement {
  const meta = KIND_META[kind];
  const handleDismissAll = () => {
    window.dispatchEvent(new CustomEvent(dismissAllEventName(kind)));
  };
  const handleApproveAll = () => {
    window.dispatchEvent(new CustomEvent(approveAllEventName(kind)));
  };
  return (
    <div className="flex gap-2.5">
      <button
        type="button"
        onClick={handleDismissAll}
        className="h-10 px-4 border border-line bg-white text-small font-semibold text-ink2 rounded-lg cursor-pointer"
      >
        {meta.dismissAllLabel}
      </button>
      <button
        type="button"
        onClick={handleApproveAll}
        className="h-10 px-[18px] bg-ink text-white text-small font-bold rounded-lg cursor-pointer border-none"
      >
        {meta.approveAllLabel}
      </button>
    </div>
  );
}